import { render, staticRenderFns } from "./CounselorFilter.vue?vue&type=template&id=1050fa73&scoped=true&"
import script from "./CounselorFilter.vue?vue&type=script&lang=js&"
export * from "./CounselorFilter.vue?vue&type=script&lang=js&"
import style0 from "./CounselorFilter.vue?vue&type=style&index=0&id=1050fa73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050fa73",
  null
  
)

export default component.exports